import CustomerHttp from 'pages/customer/services/customer.service';
import DashboardHttp from 'pages/profile/services/profile.service';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import IndicatorCard from 'shared/common/indicator-card';
import Loader from 'shared/common/loader';
import PageHeader from 'shared/page-header';
import { userStore } from 'store/UserStore';
import Layout from 'wrappers/layout';
import Pushnotification from '../login/services/login.service';

type Props = {};

const AccountSelection = (props: Props) => {
  const [loading, setLoading] = useState(false);
  const [accounts, setAccounts] = useState<any>([]);

  const [
    setCustomerId,
    setCustomer,
    setSelectedAccount,
    user,
    setUser,
    setCustomers,
  ] = userStore((state: any) => [
    state.setCustomerId,
    state.setCustomer,
    state.setSelectedAccount,
    state.user,
    state.setUser,
    state.setCustomers,
  ]);

  const history = useHistory();

  useEffect(() => {
    getUserProfile();
    document.title = 'Accounts - CoinBazaar Digital';
  }, []);

  const getUserProfile = async () => {
    setLoading(true);
    try {
      const res: any = await CustomerHttp.getUserProfile(user?.userId);
      if (res.status === 200 && res.data.data) {
        setCustomers(res.data.data.customers);
        setUser(res.data.data);
        getAccounts(
          res.data.data.customers[0].customerId,
          res.data.data.userId
        );
      }
    } catch (e: any) {
      setLoading(false);
    }
  };

  const getAccounts = async (customerId: any, userId: any) => {
    try {
      setLoading(true);
      const userData: any = await DashboardHttp.getProfile(customerId, userId);
      if (userData.status === 200 && userData.data.data) {
        setCustomerId(customerId);
        setCustomer(userData.data.data.customer);
        setAccounts(userData.data.data.customer.accounts);
      }
    } catch (e: any) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const onAccountClick = (account) => {
    setSelectedAccount(account);

    history.push('/dashboard');
  };

  return (
    <Layout isLinkShow={false}>
      {loading ? (
        <Loader />
      ) : (
        <div className='mt-3'>
          <PageHeader
            mainTitle={`Hi ${user.displayName},` || ''}
            subTitle='Welcome to CoinBazaar Digital. Please select a customer account or create a new account to continue'
            isShowSub={false}
          />
          <Row>
            <Col md={12}>
              <Row>
                {accounts.map((acc, idx) => (
                  <IndicatorCard
                    key={acc.accountId}
                    customClass={'text-left cus-card p-3 mb-4'}
                    title={acc.displayName}
                    subtitle={acc.billingAddress.state}
                    onClick={() => onAccountClick(acc)}
                    styles={{
                      color: 'white',
                      textAlign: 'left',
                    }}
                    backgroundColor={'#dda838'}
                  />
                ))}
              </Row>
            </Col>
          </Row>
        </div>
      )}
    </Layout>
  );
};

export default AccountSelection;
